import {styled} from "@mui/material";

const StyledForm = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default StyledForm;
